import React, { useRef } from 'react';
import { Avatar } from '@mantine/core';
import styles from '../../../styles/logpost.module.css';
import Heart from '../../../assets/icons/Heart';
import ChatIcon from '../../../assets/icons/ChatIcon';
import { dayjs } from '../../../utils/dayjs-utils';
import noPreviewImage from '../../../assets/images/NoPreview.png';
import { LogPost } from './types';

interface LogPostStatProps {
  leftIcon: (props: any) => React.ReactNode;
  stat?: string | number;
  disabled?: boolean;
}

function LogPostStat({ leftIcon, stat, disabled = false }: LogPostStatProps) {
  return (
    <div style={{ color: disabled ? '#BDBDBD' : '#353535' }} className={styles.logPostStatContainer}>
      {leftIcon({ color: disabled ? '#BDBDBD' : '#757575', width: 18, height: 18 })}
      <span>{disabled ? 'NA' : stat}</span>
    </div>
  );
}

const getImageUrl = (img?: string[] | string | null) => {
  if (Array.isArray(img)) return img[0];
  return img;
};

interface LogPostCardProps {
  data: LogPost;
  creatorDetails: Record<any, any>;
}

function LogPostCard({ data, creatorDetails }: LogPostCardProps) {
  const img = useRef<HTMLImageElement>(null);
  const onImageLoadError = () => {
    if (img.current) {
      img.current.src = noPreviewImage;
    }
  };

  return (
    <div className={styles.logPostCardContainer}>
      <div className={styles.logPostCardHeader}>
        <div className={styles.logPostCardAvatar}>
          <Avatar src={creatorDetails.profile_pic} alt="no image here" />
        </div>
        <div className={styles.logPostHederTextContainer}>
          <div className={styles.logPostInfluencerName}>{creatorDetails.name}</div>
          <div className={styles.logPostDateTime}>{dayjs(data?.postedDate).format('hh:mm • DD/MM/YYYY')}</div>
        </div>
      </div>
      <div className={styles.logPostCardImageContainer}>
        <img
          loading="lazy"
          crossOrigin="anonymous"
          ref={img}
          className={styles.logPostCardImage}
          src={getImageUrl(data?.postDetails?.image) || noPreviewImage}
          alt="No Preview"
          onError={onImageLoadError}
        />
      </div>
      <div className={styles.logPostFooter}>
        <LogPostStat
          leftIcon={(p) => <Heart {...p} />}
          stat={data?.postDetails?.likes}
          disabled={!data?.postDetails?.likes}
        />
        <LogPostStat
          leftIcon={(p) => <ChatIcon {...p} />}
          stat={data?.postDetails?.comments}
          disabled={!data?.postDetails?.comments}
        />
      </div>
    </div>
  );
}

export default LogPostCard;
